export const openMarketGrowthExportLink = (exportModel) => {
  const link = exportModel?.link ?? exportModel?.Link;
  if (!link) {
    throw new Error("لینک خروجی یافت نشد.");
  }
  if (String(link).startsWith("http")) {
    window.open(link, "_blank");
    return;
  }
  const base = (window.globalConfig?.API_URL || "").replace(/\/$/, "");
  const path = String(link).startsWith("/") ? link : `/${link}`;
  window.open(`${base}${path}`, "_blank");
};

export const buildExportQueryParams = (params = {}) => {
  const cleaned = { ...params, exportType: 1 };
  Object.keys(cleaned).forEach((key) => {
    const value = cleaned[key];
    if (value === "" || value === null || value === undefined) {
      delete cleaned[key];
    }
  });
  return cleaned;
};
